function lazyLoad(view) {
  return () => import(`@/views/crm/${view}.vue`)
}

export default [
  {
    path: 'sale',
    name: 'Sale users',
    component: lazyLoad('sale/UserPage'),
    meta: {
      title: 'Nhân viên sale',
      auth: true
    }
  },
  {
    path: 'sale/:id',
    name: 'Sale details',
    component: lazyLoad('sale/SaleDetails'),
    meta: {
      title: 'Nhân viên sale',
      auth: true
    }
  },
  {
    path: 'product',
    name: 'Product',
    component: lazyLoad('product/ProductPage'),
    meta: {
      title: 'Hệ đào tạo',
      auth: true
    }
  },
  {
    path: 'product/:id',
    name: 'Product details',
    component: lazyLoad('product/ProductDetails'),
    meta: {
      title: 'Hệ đào tạo',
      auth: true
    }
  },
  {
    path: 'report',
    name: 'Lead report',
    component: lazyLoad('report/LeadReport'),
    meta: {
      title: 'Báo cáo CRM',
      auth: true
    }
  },
  {
    path: 'lead',
    name: 'Lead',
    component: lazyLoad('lead/LeadPage'),
    meta: {
      title: 'Lead',
      auth: true
    }
  },
  {
    path: 'lead/:id',
    name: 'Lead details',
    component: lazyLoad('lead/leadDetails/LeadDetails'),
    meta: {
      title: 'Thông tin Lead',
      auth: true
    }
  },
]
